import { createFileRoute } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section, SectionHeader, CTABand } from "@/components/site/Blocks";
import { PageEssentials } from "@/components/site/PageEssentials";
import { buildHead } from "@/lib/seo-head";

export const Route = createFileRoute("/es/sobre-nosotros")({
  head: () =>
    buildHead({
      title: "Sobre Simply Approved Mortgages | Préstamos para Inversionistas",
      description:
        "Corredor hipotecario con licencia (NMLS #2620881) en Florida y Colorado. Préstamos DSCR, Extranjeros, Construcción, Fix & Flip, STR y Section 8 para inversionistas.",
      url: "/es/sobre-nosotros",
      locale: "es",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Sobre nosotros", url: "/es/sobre-nosotros" },
      ],
      service: { name: "Préstamos con fines comerciales para propiedades de inversión" },
    }),
  component: About,
});

function About() {
  return (
    <SiteShell>
      <PageHero
        eyebrow="Sobre nosotros"
        title="Corretaje hipotecario orientado a inversionistas de bienes raíces con fines comerciales."
        subtitle="Simply Approved Mortgages LLC (NMLS #2620881) es un corredor hipotecario con licencia enfocado en inversionistas de bienes raíces — préstamos DSCR, Extranjeros, Construcción, Fix & Flip, Airbnb / STR y Section 8. Los préstamos con fines comerciales para propiedades de inversión se gestionan en nuestra área de servicio aprobada; el corretaje residencial a consumidores está limitado a Florida y Colorado."
      />
      <PageEssentials />
      <Section>
        <SectionHeader eyebrow="Nuestra historia" title="Un solo escritorio. Todos los programas comerciales." />
        <div className="prose prose-slate mt-8 max-w-none">
          <p>
            Creamos el escritorio DSCR de Simply Approved para dar a los inversionistas inmobiliarios
            un solo punto de contacto para los negocios que realmente hacen: alquileres a largo
            plazo, compras de extranjeros, construcción de cero, flips, alquileres a corto plazo y
            portafolios Section 8.
          </p>
          <p>
            Somos un corredor hipotecario, no un prestamista. Su escenario se empaqueta y se coloca
            con socios prestamistas mayoristas cuyas pautas se ajusten al negocio; esos prestamistas
            suscriben, aprueban y financian el préstamo. Nuestro trabajo es estructurar el archivo,
            compararlo y mantener la transacción en movimiento hasta la mesa de cierre.
          </p>
          <h3>Lo que nos distingue</h3>
          <ul>
            <li><strong>Amplitud de programas.</strong> Seis programas para inversionistas — un solo equipo.</li>
            <li><strong>Comunicación clara.</strong> Revisión inicial del escenario en presentaciones completas — generalmente el mismo día hábil. La cotización formal y los términos siguen a la suscripción del prestamista.</li>
            <li><strong>Amigable con entidades.</strong> Vestimenta en LLC, LP, S-Corp, C-Corp y Series LLC es comúnmente aceptada en programas con fines comerciales.</li>
            <li><strong>Licencias.</strong> Simply Approved Mortgages LLC, NMLS #2620881 — Florida Mortgage Broker License #MBR7685 y registro de compañía hipotecaria de Colorado para actividad residencial a consumidores; préstamos con fines comerciales para propiedades de inversión en jurisdicciones adicionales aprobadas.</li>
          </ul>
        </div>
      </Section>

      <CTABand title="Hable con un oficial de préstamos para inversionistas" body="Envíenos su escenario. Respuestas reales, cotizaciones reales." />
    </SiteShell>
  );
}
